module.exports = __webpack_public_path__ + "img/other.e3e540be.svg";